import { render, staticRenderFns } from "./ResumenCarritoComponent.vue?vue&type=template&id=7889bc22&scoped=true"
import script from "./ResumenCarritoComponent.vue?vue&type=script&lang=js"
export * from "./ResumenCarritoComponent.vue?vue&type=script&lang=js"
import style0 from "./ResumenCarritoComponent.vue?vue&type=style&index=0&id=7889bc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889bc22",
  null
  
)

export default component.exports